import React, { Component, useContext } from 'react';
import { Route } from 'react-router';
import { withRouter } from 'react-router-dom';
import { AppContext } from './AppContext';
import { authService } from './services/auth.service';
import { createBrowserHistory } from 'history';

import { AuthLayout } from './layouts/AuthLayout';
import { Home } from './components/Home';
import { MisParalelos } from './components/MisParalelos';
import UnidadEvaluacion from './components/UnidadEvaluacion';
import { ProgramaEvaluacion } from './components/ProgramaEvaluacion';
import UnidadParalelos from './components/UnidadParalelos';
import { Materias } from './components/Materias';
import { ParalelosMateria } from './components/ParalelosMateria';
import { Profesores } from './components/Profesores';
import { ParalelosProfesor } from './components/ParalelosProfesor';
import { Paralelo } from './components/Paralelo';
import { Practica } from './components/Practica';
import { Comentarios } from './components/Comentarios';
import ComentariosPractica from './components/ComentariosPractica';
import UserManagement from './components/UserManagement';
import ReportesConsolidados from './components/ReportesConsolidados';
import ImpersonateUser from './components/ImpersonateUser';
import UnauthorizedAccess from './components/UnauthorizedAccess';

import { GraficoParaleloArea } from './components/GraficoParaleloArea';

import './assets/css/main.css';
import { Switch } from 'react-router-dom';

import Cookies from 'universal-cookie';
import jwt from 'jsonwebtoken';

const history = createBrowserHistory();
const cookies = new Cookies();

const BASEURL = process.env.REACT_APP_BASE_URL;

const publicRoutes_prefix = ["/materias", "/profesores", "/paralelos-profesor", "/paralelos-materia", "/paralelo/", "/api/", "/images/graficos/"];
const publicRoutes_exact = ["", "/"];

class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);

        this.state = {
            currentUser: null
        };
    }

    componentDidCatch(error, errorInfo) {
        console.log("error = " + error + " errorInfo = " + errorInfo);
    }

    componentDidMount() {
        const { currentUser } = this.state;
        const { pathname } = history.location;

        const authToken = cookies.get('authToken');

        if (authToken) {
            try {
                const decodedToken = jwt.decode(authToken);
                if (isTokenExpired(decodedToken)) {
                    cookies.remove('authToken', { path: '/' });
                    cookies.remove('impersonateToken', { path: '/' });
                } else {
                    const impToken = cookies.get('impersonateToken');
                    const decodedImpToken = jwt.decode(impToken);
                    if (impToken) {
                        authService.validateToken(impToken, decodedImpToken, true);
                    } else {
                        authService.validateToken(authToken, decodedToken);
                    }
                    this.subscription = authService.currentUser.subscribe(currentUser => {
                        if (currentUser) {
                            this.setState({ currentUser: currentUser });
                        }
                    });
                    return;
                }
            } catch (error) {
                console.error('Token decoding error:', error);
            }
        }

        if (!currentUser || currentUser == undefined) {
            if (publicRoutes_prefix.map(pr => pathname.startsWith(`${BASEURL}${pr}`)).some(pr => pr) || publicRoutes_exact.map(pr => pathname == `${BASEURL}${pr}`).some(pr => pr) || publicRoutes_exact.includes(pathname)) {
                authService.login(history, true);
            } else {
                authService.login(history);
            }

            this.subscription = authService.currentUser.subscribe(currentUser => {
                if (currentUser) {
                    this.setState({ currentUser: currentUser });
                }
            });
        }
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    startImpersonation = (impersonationToken) => {
        const decodedToken = jwt.decode(impersonationToken);
        authService.validateToken(impersonationToken, decodedToken, true);
        cookies.set('impersonateToken', impersonationToken, {
            path: '/'
        });
        authService.setGlobalFetch();
    };

    revertToOriginalUser = () => {
        const originalToken = cookies.get('authToken');
        const decodedToken = jwt.decode(originalToken);
        authService.validateToken(originalToken, decodedToken);
        cookies.remove('impersonateToken', { path: '/' });
        this.props.history.push('/');
        authService.setGlobalFetch();
    };

    render() {
        const { currentUser } = this.state;

        return (
            <AppContext.Provider value={{ ...this.state, startImpersonation: this.startImpersonation, revertToOriginalUser: this.revertToOriginalUser }}>
                <Switch>
                    <Route path='/grafico-area/:anio/:termino/:codigo/:paralelo/:identificacion/:area' component={GraficoParaleloArea} />
                    <AuthLayout currentUser={currentUser}>
                        <Route exact path='/' component={Home} />
                        <Route path="/unauthorized" component={UnauthorizedAccess} />
                        <Route path='/usuarios' component={UserManagement} />
                        <Route path='/impersonate' component={ImpersonateUser} />
                        <Route path='/materias/:page?/:size?/:search1?/:search2?' component={Materias} />
                        <Route path='/profesores/:page?/:size?/:search1?/:search2?' component={Profesores} />
                        <Route path='/mis-paralelos/:page?/:size?' component={MisParalelos} />
                        <Route path='/unidad-evaluacion/:unidad?/:anio?/:termino?/:page?/:size?' component={UnidadEvaluacion} />
                        <Route path='/programa-evaluacion/:unidad?/:programa?/:cohorte?/:anio?/:termino?/:page?/:size?' component={ProgramaEvaluacion} />
                        <Route path='/paralelos-unidad/:unidad?/:anio?/:termino?/:page?/:size?' component={UnidadParalelos} />
                        <Route path='/paralelos-materia/:codigo/:page?/:size?' component={ParalelosMateria} />
                        <Route path='/paralelos-profesor/:identificacion/:page?/:size?' component={ParalelosProfesor} />
                        <Route path='/paralelo/:anio/:termino/:codigo/:paralelo/:identificacion/:modo?' component={Paralelo} />
                        <Route path='/practica/:anio/:codigo/:identificacion/:modo?' component={Practica} />
                        <Route path='/practica-comentarios/:anio/:codigo/:identificacion' component={ComentariosPractica} />
                        <Route path='/reportes-consolidados' component={ReportesConsolidados} />
                        <Switch>
                            <Route path='/paralelo-comentarios/:anio/:termino/:codigo/:paralelo/:identificacion/:idnivelformacion?' component={Comentarios} />
                            <Route path='/paralelo-comentarios/:sistema/:idcurso/:idpersona' component={Comentarios} />
                        </Switch>
                    </AuthLayout>
                </Switch>
            </AppContext.Provider>
        );
    }
}

function isTokenExpired(tokenObj) {
    if (!tokenObj || !tokenObj.exp) {
        return true;
    }
    const currentTime = Math.floor(Date.now() / 1000);
    return tokenObj.exp < currentTime;
}

export default withRouter(App);